import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

import { defaultParams } from './constants'

const useRegions = ({ doInitialRequest } = defaultParams) => {
  const { data, loading, fetchData } = useFetch(commonServices.getRegions, {
    doInitialRequest,
    cache: true,
    cacheKey: 'regions',
    cacheTTL: 60000 * 60,
  })

  const getProvincesByCountryCode = countryCode => {
    return (
      data?.results
        .find(region => region.code === countryCode)
        ?.provinces?.map(p => ({ label: p.name, value: p.code })) || []
    )
  }

  return { regions: data?.results || [], loading, fetchData, getProvincesByCountryCode }
}

export default useRegions
